import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '@shared/utils/util';
import { Platform } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { LocationService } from '@shared/services/location.service';
import { UserService } from '@shared/services/user.service';
import { UserModel } from '@shared/models/user.model';
import { HttpClient } from '@angular/common/http';
import { FcmService } from '@shared/services/fcm.service';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { SignupWithEmailPage } from '../signup-with-email/signup-with-email.page';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { MatchService } from 'src/app/services/match.service';
import { environment, webVersion } from 'src/environments/environment';
import { FacebookUser } from '@shared/interfaces/facebook-user-interface';
import { FacebookService } from '@shared/services/facebook.service';
import { Capacitor } from '@capacitor/core';
@Component({
  selector: 'app-login-shared',
  templateUrl: './login-shared.page.html',
  styleUrls: ['./login-shared.page.scss'],
  providers: [UtilService, UserService, NavParams]
})
export class LoginSharedPage implements OnInit {

  public isNative: boolean = this.util.isNative();
  public isIos: boolean = true;
  public deviceInfo: any;
  public userData: any = {}; // Initialize with an empty object
  public imageFB: string = '';
  public processingAppleSignin: boolean = false;
  public processingGoogleSignin: boolean = false;
  public processingFacebookSignin: boolean = false;
  public userLoggedIn: boolean = false;
  public submitAttempt: boolean = false;
  public referralUserId: string = "";
  public otherUserData: any;
  private hasReloaded = false;

  myForm = new FormGroup({
    emailControl: new FormControl('', Validators.compose([Validators.maxLength(50), Validators.email, Validators.required])),
    userpassControl: new FormControl('', Validators.compose([Validators.maxLength(15), Validators.required])),
  });

  public myImageFB: any;

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private facebookService: FacebookService,
    public loadingCtrl: LoadingController,
    private translate: TranslateService,
    private util: UtilService,
    public platform: Platform,
    private locationService: LocationService,
    private userService: UserService,
    private userModel: UserModel,
    private http: HttpClient,
    private fcm: FcmService,
    private route: ActivatedRoute,
    public toastCtrl: ToastController,
    private analytics: AnalyticsService,
    public navParams: NavParams,
    public router: Router,
    private matchService: MatchService
  ) {
    platform.ready().then(() => {
      this.route.queryParams.subscribe(params => {
        this.referralUserId = params['referralUserId'];
      });


      // console.log("referralUserId"+this.referralUserId);
      let isModal = this.navParams.get('isModal');
      this.getInfosUserById();
      if (isModal != null && isModal == "true" && !this.hasReloaded) {
        this.hasReloaded = true;
      }

      this.util.initTranslate()
      this.isNative = this.util.isNative()
      this.isIos = !platform.is('android');

      console.log('this.isIos:' + this.isIos);
      console.log('this.isNative:' + this.isNative);
      console.log('ipad:' + platform.is('ipad'));

      console.log('_platforms:' + platform.platforms());


      console.log('UtilService.loggedOut:' + UtilService.loggedOut);


      if (!UtilService.loggedOut) {
        Preferences.get({ key: 'USER_DATA' }).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          console.log('login constructor userdata: ' + val);
          if (val != null) {
            this.modalCtrl.dismiss();
          }
        })
      }
    })

  }

  ngOnInit() {
    this.getDevice();
  }

  async ionViewDidEnter() {
    //this.element.nativeElement.getElementsByTagName('ion-tabbar').style.display = 'none';
    //this.tabs._elementRef.nativeElement.style.display = 'none';
    const tabBar = document.getElementById('app-tab-bar');
    if (tabBar !== null) {
      tabBar.style.display = 'none';
    }


    console.log('ionViewDidEnter LoginPage');

    console.log('UserService.loggedOut:' + UserService.loggedOut);

    if (!UserService.loggedOut) {

      Preferences.get({ key: 'USER_DATA' }).then((val) => {
        val = val.value ? JSON.parse(val.value) : null;
        console.log('login ionViewDidEnter userdata: ' + val);

        if (val != null) {
          this.modalCtrl.dismiss();
        }
      })

    }

  }

  private loader = this.loadingCtrl.create({
    message: this.translate.instant('msgOneMomentPlease'),
  });


  getInfosUserById() {
    this.userService.viewProfilePublic(this.referralUserId).subscribe({
      next: (data) => {
        if (data != '{not ok}') {
          this.otherUserData = JSON.parse(data);
          if (this.otherUserData.firstPic?.$oid) {
            this.otherUserData.firstPic = this.userService.getImageURL(this.otherUserData.firstPic.$oid);
          } else {
            this.otherUserData.firstPic = ""
          }

        }
      },
      error: async (error) => {
        console.log('Upsert error: ' + JSON.stringify(error.toString()));
        (await this.loader).dismiss();
      }
    });

  }


  async getDevice() {
    const device = await Device.getInfo();
    if (this.util.isNative()) {
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: (await App.getInfo()).version,
      };

    } else {
      // Browser
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: webVersion
      }

    }
    this.userModel.device = this.deviceInfo
  }

  exit() {
    this.modalCtrl.dismiss();
  }

  async showModalAlert(message: string) {
    let alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }


  async showLoading(message: string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      // translucent: true,

      // backdropDismiss: true
    });

    loading.present();
  }
  loginWithPassword() {
    this.submitAttempt = true;
    if (!this.myForm.valid) {
      this.showModalAlert(this.translate.instant('fixHighlighted'));
    } else {
      this.showLoading(this.translate.instant('pleaseWait'));
    }
  }

  async goToForgotPasswordPage() {
    console.log("teste");

  }


  async openDefaultLogin() {
    UtilService.loggedOut = false;
    const modal = await this.modalCtrl.create({
      component: SignupWithEmailPage,
      componentProps: {
        referralUserId: this.referralUserId,
        isModal: true
      },
    });

    (await modal).onDidDismiss().then((val) => {
      if (val && val.data === "loggedIn") {
        this.modalCtrl.dismiss('loggedIn');
        UserService.loggedOut = false;
        this.router.navigateByUrl('/tabs/my-profile-display');
      }
    });
    modal.present();

  }


  async googleSignIn() {
    let clientId: string = '';

    if (!Capacitor.isNativePlatform()) {
      clientId = environment.googleAuth.web;
    } else if (this.isIos) {
      clientId = environment.googleAuth.ios;
    } else {
      clientId = environment.googleAuth.android;
    }

    // Verificar se o clientId está definido
    if (!clientId) {
      throw new Error('Google Auth Client ID não encontrado');
    }

    console.log('Inicializando Google Auth...');
    console.log('Client ID sendo usado:', clientId);
    console.log('Server Client ID:', environment.googleAuth.web);

    await GoogleAuth.initialize({
      clientId: clientId,
      scopes: ['profile', 'email'],
      grantOfflineAccess: true,
    });
    console.log('Google Auth inicializado com sucesso');

    this.processingGoogleSignin = true;
    try {
      const googleUser = await GoogleAuth.signIn();
      console.log('Google Authentication Result:', googleUser);
      // Handle authentication success
      if (googleUser.email == undefined || googleUser.email == null || googleUser.email == '') {
        this.showModalAlert(this.translate.instant('googleNoEmail'));
        return;
      }

      this.userData = {
        email: googleUser.email
      };

      if (this.referralUserId != null) {
        this.userData.referralUserId = this.referralUserId
      }

      if ((googleUser as any).googleUserId != null) {
        this.userData.googleUserId = (googleUser as any).googleUserId
      }
      if (googleUser.name != null) {
        this.userData.displayName = googleUser.name
      }
      if (googleUser.givenName != null) {
        this.userData.firstName = googleUser.givenName
      }
      if (googleUser.familyName != null) {
        this.userData.lastName = googleUser.familyName
      }
      if (googleUser.authentication.refreshToken != null) {
        this.userData.googleRefreshToken = googleUser.authentication.refreshToken
      }
      if (googleUser.serverAuthCode != null) {
        this.userData.googleServerAuthCode = googleUser.serverAuthCode
      }

      if (googleUser.authentication.accessToken != null) {
        this.userData.googleAccessToken = googleUser.authentication.accessToken
      }
      if (googleUser.authentication.idToken != null) {
        this.userData.googleIdToken = googleUser.authentication.idToken
      }
      this.registerLoginEvents();
      this.saveProfile(null);
    } catch (error) {
      console.error('Google Authentication Error:', error);

      // Tratamento específico para diferentes tipos de erro
      let errorMessage = 'Erro desconhecido';

      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else if (error && typeof error === 'object') {
        errorMessage = (error as any).message || JSON.stringify(error);
      }

      // Logs específicos para debugging em produção
      console.error('Google Auth Error Details:', {
        message: errorMessage,
        platform: Capacitor.isNativePlatform() ? (this.isIos ? 'iOS' : 'Android') : 'Web',
        clientId: environment.googleAuth[Capacitor.isNativePlatform() ? (this.isIos ? 'ios' : 'android') : 'web'],
        timestamp: new Date().toISOString()
      });

      this.processingGoogleSignin = false;
      this.showModalAlert('Erro no login do Google: ' + errorMessage);
    }
  }

  async loginWithFB() {
    this.processingFacebookSignin = true;
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
      duration: 3000,
    });

    try {
      try {
        const accessToken = await this.facebookService.login();
        let facebookUser: FacebookUser = await this.facebookService.getUserData();
        console.log('User Data:', facebookUser);
        if (accessToken) {
          // const responseGraphFacebook = await fetch(`https://graph.facebook.com/${response.accessToken?.userId}?fields=id,name,email,birthday,first_name,last_name,picture.width(800).height(800).as(picture_large)&access_token=${response.accessToken?.token}`);
          // const userDataFB = await responseGraphFacebook.json();
          this.userData = facebookUser;
          if (this.referralUserId != null) {
            this.userData.referralUserId = this.referralUserId
          }
          this.registerLoginEvents();
          this.saveProfile(facebookUser['picture']['data']['url']);
        } else {
          console.error('Falha no login do Facebook');
        }
      } catch (error) {
        console.error('Facebook Login Error:', error);
      }
    } catch (error) {
      console.error('Erro ao fazer login no Facebook:', error);
      this.processingFacebookSignin = false;
    }

    loading.present();
  }




  private async saveProfile(localPicture: any) {
    const lastLocation = await Preferences.get({ key: 'LAST_LOCATION' });
    let location = lastLocation?.value ? JSON.parse(lastLocation.value) : { type: 'Point', coordinates: [environment.locationDefault.coordinates[0], environment.locationDefault.coordinates[1]] };
    let teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      location = teleportationLocation;
    }

    // Retrieve and add FCM token to userData before sending to server
    console.log('=== Attempting to retrieve FCM token ===');
    let tokenValue = null;

    // Try Preferences first
    const fcmToken = await Preferences.get({ key: 'TOKEN' });
    if (fcmToken && fcmToken.value) {
      tokenValue = fcmToken.value;
      console.log('FCM token found in Preferences:', tokenValue);
    } else {
      console.log('No FCM token in Preferences, checking localStorage');
      // Fallback to localStorage
      const localToken = localStorage.getItem('TOKEN');
      if (localToken) {
        tokenValue = localToken;
        console.log('FCM token found in localStorage:', tokenValue);
      } else {
        console.log('No FCM token found in either storage location');
      }
    }

    if (tokenValue) {
      this.userData.token = tokenValue;
      console.log('FCM token successfully added to userData');
      console.log('userData object before upsertSoul:', JSON.stringify(this.userData));
    }

    this.userService
      .upsertSoul(this.userData, location, false, false, true)
      .subscribe(
        {
          next: async (data) => {
            if (data != '{not ok}') {
              this.userModel = JSON.parse(data);

              // Send image to Server
              let serverPicture = this.userData.picture0;

              if (localPicture != null && serverPicture == null) {
                this.userData = JSON.parse(data);
                this.http.get(localPicture, { responseType: 'blob' })
                  .subscribe(
                    {
                      next: (response: Blob) => {
                        const fileReader = new FileReader();
                        const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
                        const reader = zoneOriginalInstance || fileReader;

                        reader.onloadend = async () => {
                          let uploadImageFB = this.setFirstPicture();
                          if (uploadImageFB) {
                            this.imageFB = reader.result as string;
                            let filename: string = 'picture' + 0;
                            this.userService
                              .uploadImage64(this.imageFB, this.userModel, filename)
                              .subscribe(
                                {
                                  next: async (data) => {
                                    this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                                    this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                                    this.userModel.filename = { '$oid': data };
                                    this.userModel.picture0 = { '$oid': data };
                                    await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
                                      this.storeUserLocally();
                                    });
                                  },
                                  error: (err) => {
                                    //alert('uploadImage error: ' + JSON.stringify(err));
                                  }
                                }
                              )
                          } else {
                            this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                            this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                            await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
                              this.storeUserLocally();
                            });
                          }

                        }


                        reader.readAsDataURL(response);

                      },
                      error: (erro) => {
                        //alert("Usuário ou Senha inválido(s)!");
                        console.log(erro)
                      }
                    }
                  )
              } else {
                this.userData = JSON.parse(data);
                await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
                  this.storeUserLocally();
                });
              }
            }
          },
          error: (erro) => {
            //alert("Usuário ou Senha inválido(s)!");
            console.log(erro)
            this.processingGoogleSignin = false;
            this.processingFacebookSignin = false;
            this.processingAppleSignin = false;
          }
        }
      )



  }

  setFirstPicture() {
    let picnum: number;
    let picCount: number = 0;
    let data2: any = this.userModel
    for (picnum = 0; picnum < 9; picnum++) {
      let aPic: string = "picture" + picnum;
      if (data2[aPic]) {
        picCount++;
      }
    }
    if (picCount == 0) {
      return true;
    }
    return false
  }

  private async storeUserLocally() {
    // Store locally
    console.log('Stored UserData = ' + JSON.stringify(this.userData));
    
    // Restore teleportation location from local storage if it exists (before setting USER_DATA)
    const savedTeleportLocation = await Preferences.get({ key: 'TELEPORT_LOCATION' });
    if (savedTeleportLocation && savedTeleportLocation.value) {
      const teleportLocation = JSON.parse(savedTeleportLocation.value);
      console.log('storeUserLocally: Restoring teleportation location from local storage: ' + JSON.stringify(teleportLocation));
      
      // Restore teleportation location to LocationService
      (this.locationService as any).teleportLocation = teleportLocation;
      
      // If server response doesn't have teleportation info, restore it from local storage
      if (this.userModel) {
        if (!this.userModel.usingTeleportation || !this.userModel.location) {
          console.log('storeUserLocally: Server response missing teleportation info, restoring from local storage');
          this.userModel.usingTeleportation = true;
          this.userModel.location = teleportLocation;
        }
      }
    }
    
    // If user is using teleportation and server response has location, save it to TELEPORT_LOCATION
    if (this.userModel && this.userModel.usingTeleportation && this.userModel.location) {
      console.log('storeUserLocally: User is using teleportation, saving location to TELEPORT_LOCATION: ' + JSON.stringify(this.userModel.location));
      await Preferences.set({ key: 'TELEPORT_LOCATION', value: JSON.stringify(this.userModel.location) });
      console.log('TELEPORT_LOCATION saved to Preferences');
      // Update LocationService in-memory cache
      (this.locationService as any).teleportLocation = this.userModel.location;
    }
    
    await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((val) => {
      //this.fcm.getToken();
      console.log('Will set UserService.loggedOut to false. Current value: ' + UserService.loggedOut);
      UserService.loggedOut = false;
      this.processingGoogleSignin = false;
      this.processingFacebookSignin = false;
      this.processingAppleSignin = false;
      this.restartMatchService();
      localStorage.setItem('USER_LOGGED', 'true')
      Preferences.set({ key: 'USER_LOGGED', value: 'true' }).then(() => {
        console.log("userLogged saved to DB");
      });
      this.showWelcomeBackMsg();
      
      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
        console.log('userModel saved to Preferences with new location');
        Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
          val = val.value ? JSON.parse(val.value) : null;

          console.log("val.interest:", val.interest2);

          if (val.interest2 != null) {
            console.log(this.userData.interest2);
            this.router.navigateByUrl('/tabs/home');
          } else {
            console.log(this.userData.interest2);
            this.router.navigateByUrl('/tabs/my-profile-display');
          }

        });
      });
    });
  }

  registerLoginEvents() {
    // Your logic for registering login events
    Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (this.userService.checkUserHasPicture(val)) {
        this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
        if (val.sign_up_compl_ok)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpComplOk, true);
        if (val.valuable_user)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuable, true);
      }
    })
  }

  showWelcomeBackMsg() {
    if (this.userModel.wasOnHibernate != null) {
      this.showModalAlert(this.translate.instant('welcomeBackFromHibernate'));
      delete this.userModel.wasOnHibernate;

      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
        console.log('login.showWelcomeBackMsg: saved user without the wasOnHibernate');
      });
    }
  }

  async presentToast(msg: string, dur: number) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: dur,
      buttons: [
        {
          text: this.translate.instant('close'),
          role: 'cancel',
        }
      ],

    });
    (await toast).present();
  }

  downloadImage(pathImg: any) {
    this.http.get(pathImg, { responseType: 'blob' })
      .subscribe(res => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.myImageFB = reader.result?.toString();

          let filename: string = 'picture' + 0;
          this.userService.uploadImage64(this.myImageFB, this.userData, filename).subscribe(
            data => {
              console.log('upload image succesful');
              console.log('data returned JSON.stringify: [' + JSON.stringify(data) + ']');
              this.userData[filename] = { '$oid': data };
              Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then(() => {
                console.log('userdata saved to Preferences with new location');
              });
            },
            err => {
              console.log('uploadImage error: ' + JSON.stringify(err));
            });
        };
        reader.readAsDataURL(res);
      });
  }

  private restartMatchService() {
    this.matchService.restartRefresh();
  }
  private createFileName(index: number) {
    return 'picture' + index + '.jpg';
  }
}
